import React, { useState, useMemo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import JumboPayInvoiceDetails from "./JumboPaySettingsComponents/JumboPayInvoiceDetails.js";
import BankListSettings from "./JumboPaySettingsComponents/BankListSettings.js";
import PayPalListSettings from "./JumboPaySettingsComponents/PayPalListSettings.js";

const JumboPaySettings = ({userFullDetails }) => {
  const { getTextByKey } = useContent();

  const [banksAccount, setBanksAccount] = useState([]);

  const [paypalAccounts, setPaypalAccounts] = useState([]);

  useMemo(() => {
    //convert the object to array
    const objectBanks = userFullDetails.User_BankAccounts;
    let banks = [];
    if (objectBanks) {
      for (let key in objectBanks) {
        let item = objectBanks[key];
        item.keyIndex = key;
        banks.push(item);
      }
    }
    setBanksAccount(banks);
    const objectPaypal = userFullDetails.User_PaypalAccounts;
    let paypals = [];
    if (objectPaypal) {
      for (let key in objectPaypal) {
        let item = objectPaypal[key];
        item.keyIndex = key;
        paypals.push(item);
      }
    }
    setPaypalAccounts(paypals);
  }, []);

  return (
    <div className="jumbopay-settings-container">
      <div className="jumbopay-settings-header">
        <h3>{getTextByKey("profile-menu-jumbopay-settings")}</h3>
      </div>
      <div className="jumbopay-settings-content">
        <JumboPayInvoiceDetails userFullDetails={userFullDetails} />
        <div className="bank-settings">
          <h4>{getTextByKey("profile-menu-jumbopay-bank-settings")}</h4>
          <div
            className={`bank-settings-container  ${
              banksAccount.length > 0 || paypalAccounts.length > 0
                ? "column"
                : "row"
            }`}
          >
            <BankListSettings
              banksAccount={banksAccount}
              setBanksAccount={setBanksAccount}
              paypalAccounts={paypalAccounts}
              setPaypalAccounts={setPaypalAccounts}
            />
            <PayPalListSettings
              banksAccount={banksAccount}
              setBanksAccount={setBanksAccount}
              paypalAccounts={paypalAccounts}
              setPaypalAccounts={setPaypalAccounts}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JumboPaySettings;
